import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
export default new Router({
    routes: [{
            path: '/',
            name: 'login',
            component: () =>
                import ('./views/Login.vue'),
            show: 0,
        },
        {
            path: '/data',
            name: '参赛数据',
            icon: 'el-icon-s-home',
            component: () =>
                import ('./views/Home.vue'),
            show: 1,
            isLeaf: 0,
            children: [{
                    path: '/data',
                    component: () =>
                        import ('./views/data/index.vue'),
                    name: '数据统计'
                },
                {
                    path: '/fundinout',
                    component: () =>
                        import ('./views/data/fundInOut.vue'),
                    name: '资金出入'
                }
            ]
        },
        {
            path: '/comments',
            name: '咨询顽主',
            icon: 'el-icon-s-comment',
            component: () =>
                import ('./views/Home.vue'),
            show: 1,
            isLeaf: 1,
            children: [
                {
                    path: '/comments',
                    component: () =>
                        import ('./views/comments/consult.vue'),
                    name: '咨询顽主'
                }
            ]
        },
        {
            path: '/signup',
            name: '订单管理',
            icon: 'el-icon-s-finance',
            component: () =>
                import ('./views/Home.vue'),
            show: 1,
            isLeaf: 1,
            children: [{
                path: '/signup',
                component: () =>
                    import ('./views/signup/index.vue'),
                name: '订单管理'
            }, ]
        },
        {
            path: '/player',
            name: '选手管理',
            icon: 'el-icon-user',
            component: () =>
                import ('./views/Home.vue'),
            show: 1,
            isLeaf: 1,
            children: [{
                path: '/player',
                component: () =>
                    import ('./views/player/index.vue'),
                name: '参赛选手'
            }]
        },
        {
            path: '/user',
            name: '用户管理',
            icon: 'el-icon-s-custom',
            component: () =>
                import ('./views/Home.vue'),
            show: 1,
            isLeaf: 1,
            children: [{
                path: '/user',
                component: () =>
                    import ('./views/user/index.vue'),
                name: '用户管理'
            }, ]
        },
        {
            path: '/baike',
            name: '短线百科',
            icon: 'el-icon-s-grid',
            component: () =>
                import ('./views/Home.vue'),
            show: 1,
            isLeaf: 0,
            children: [
                {
                    path: '/baike/term',
                    component: () =>
                        import ('./views/baike/Index.vue'),
                    name: '百科词条'
                }
            ]
        },
        
        {
            path: '/comments',
            name: '留言管理',
            icon: 'el-icon-tickets',
            component: () =>
                import ('./views/Home.vue'),
            show: 1,
            isLeaf: 0,
            children: [{
                    path: '/stock/comments/list',
                    component: () =>
                        import ('./views/comments/stockComments.vue'),
                    name: '股票留言'
                },
                {
                    path: '/record/comments/list',
                    component: () =>
                        import ('./views/comments/recordComments.vue'),
                    name: '作业留言'
                },
                {
                    path: '/stock/nbcomments/list',
                    component: () =>
                        import ('./views/comments/stockNBComments.vue'),
                    name: '牛人点评'
                },
                // {
                //     path: '/famous/list',
                //     component: () =>
                //         import ('./views/comments/famousUserList.vue'),
                //     name: '名人堂'
                // }
            ]
        },
        {
            path: '/match',
            name: '赛事管理',
            icon: 'el-icon-trophy-1',
            component: () =>
                import ('./views/Home.vue'),
            show: 1,
            isLeaf: 0,
            children: [{
                    path: '/match',
                    component: () =>
                        import ('./views/match/index.vue'),
                    name: '赛事管理'
                }, {
                    path: '/group',
                    component: () =>
                        import ('./views/match/group.vue'),
                    name: '赛事分组'
                }, {
                    path: '/notice',
                    component: () =>
                        import ('./views/match/notice.vue'),
                    name: '赛事公告'
                },
                {
                    path: '/addNotice',
                    component: () =>
                        import ('./views/match/addArticle.vue'),
                    name: '新增公告',
                    hide: 1,
                    isLeaf: 1
                },
                {
                    path: '/championsay',
                    component: () =>
                        import ('./views/match/championSay.vue'),
                    name: '文章数据'
                },
                {
                    path: '/addChampionSay',
                    component: () =>
                        import ('./views/match/addChampionSay.vue'),
                    name: '新增冠军心得',
                    hide: 1,
                    isLeaf: 1
                },
                {
                    path: '/stock',
                    component: () =>
                        import ('./views/match/stock.vue'),
                    name: '股票仓库'
                }
            ]
        },
        {
            path: '/sys',
            name: '系统管理',
            icon: 'el-icon-mobile',
            component: () =>
                import ('./views/Home.vue'),
            show: 1,
            isLeaf: 0,
            children: [{
                    path: '/sys/version',
                    component: () =>
                        import ('./views/sys/Version.vue'),
                    name: '版本管理'
                }
            ]
        }
    ]
})